import { useMemo } from "react";
import { RegisterData } from "@/modules/types/auth";
import { apiClient } from "@/lib/api/api-client";
import { useAuthStore } from "@/modules/store/authStore";
import { authService } from "@/modules/services/authService";

export function useAuth() {
  const { token, setToken, setRefreshToken, logout } = useAuthStore();

  const isAuthenticated = useMemo(() => {
    return !!token;
  }, [token]);

  const login = async (
    email: string,
    password: string,
    isSaveLogin?: boolean,
  ) => {
    const response = await authService.login({
      email,
      password,
      isSaveLogin,
    });
    apiClient.setToken(response.token);
    setToken({
      token: response.token,
      expired: response.expiredAt,
    });
    setRefreshToken({
      refreshToken: response.refreshToken,
      expired: response.expiredAt + 3600,
    });
    return response;
  };

  const register = async (userData: RegisterData) => {
    const response = await authService.register(userData);
    apiClient.setToken(response.token);
    setToken({
      token: response.token,
      expired: response.expiredAt,
    });
    setRefreshToken({
      refreshToken: response.refreshToken,
      expired: response.expiredAt + 3600,
    });
    return response;
  };

  return {
    login,
    register,
    logout,
    isAuthenticated,
  };
}
